module.exports = __webpack_public_path__ + "img/boy.19c3ae80.png";